<template>
  <v-layout class="grey lighten-4" column>
    <v-toolbar :flat="true" color="transparent">
      <v-toolbar-title class="primary--text">Saldo de {{ restaurant.name }}</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-flex xs12>
      <v-row>
        <v-col>
          <v-card height="100%">
            <v-card-title class="primary">
              <div class="white--text d-flex align-center">
                <v-icon color="white" class="mr-3">
                  mdi-cash-usd
                </v-icon>
                Cuenta de depósito
              </div>
            </v-card-title>
            <v-card-text>
              <div class="mt-1 mb-4">
                <v-alert
                  v-if="!taxInformation.taxId && !taxInformation.taxName"
                  outlined
                  prominent
                  type="warning"
                >
                  <v-row align="center">
                    <v-col class="grow">
                      No tienes configurados datos fiscales en el restaurante, son necesarios para poder otorgarte una cuenta clabe.
                    </v-col>
                    <v-col class="shrink">
                      <v-btn text :to="{ name: 'RestaurantSettings' }">Ir a datos fiscales</v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
                <div v-else>
                  <div v-if="detail.paymentData">
                    <div class="subtitle-1" v-if="detail.paymentData.accountV2">
                      Banco:
                    </div>
                    <div v-if="detail.paymentData.accountV2">
                      <div class="title">
                        {{ detail.paymentData.accountV2.bank_name }}
                      </div>
                      <div class="subtitle-1" v-if="detail.paymentData.accountV2.clabe">
                        CLABE Eato:
                      </div>
                      <div class="title">
                        {{ detail.paymentData.accountV2.clabe || '' }}
                      </div>
                      <v-alert
                        prominent
                        colored-border
                        border="top"
                        elevation="2"
                        type="info"
                        class="mt-3"
                      >
                        <v-row align="center">
                          <v-col class="grow">
                            Para cargar saldo a tu cuenta de eato.mx, solo debes hacer el depósito a la cuenta clabe que te proporcionamos.
                          </v-col>
                        </v-row>
                      </v-alert>
                    </div>
                    <div v-else>
                      <!-- <div
                        v-if="detail.paymentData.source"
                        class="title">
                        {{ detail.paymentData.source.bank_name }}
                      </div>
                      <div class="subtitle-1" >
                        CLABE Eato:
                        <v-tooltip
                          max-width="300"
                          right>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              v-on="on"
                            >
                              <v-icon color="warning">
                                mdi-alert
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>
                            Esta clabe pronto quedará inutilizable, te sugerimos que generes una nueva a la brevedad para que puedas aumentar saldo a tu cuenta.
                          </span>
                        </v-tooltip>
                      </div>>
                      <div
                        v-if="detail.paymentData.source"
                        class="title">
                        {{ detail.paymentData.source.clabe || '' }}
                      </div>-->
                    </div>
                    <!-- <div class="mt-3" v-if="!detail.paymentData.account">
                      <v-btn
                        :loading="loading"
                        :disabled="loading"
                        rounded
                        color="primary"
                        @click="generateClabe">
                        Generar nueva clabe
                      </v-btn>
                    </div> -->
                  </div>
                  <div v-else class="d-flex flex-column align-center justify-space-between">
                    <div class="title">
                      Aún no tienes método de pago
                    </div>
                    <!-- <div class="mt-3" v-if="!detail.paymentData.account">
                      <v-btn
                        :loading="loading"
                        :disabled="loading"
                        rounded
                        color="primary"
                        @click="generateClabe">
                        Generar nueva clabe
                      </v-btn>
                    </div> -->
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card height="100%">
            <v-card-title class="blue-grey darken-3 white--text">
              <div class="d-flex justify-space-between" style="width: 100%">
                <div>
                  Información de saldo
                </div>
                <!-- <v-tooltip
                  max-width="300"
                  left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      dark
                      v-on="on"
                    >
                      <v-icon>
                        mdi-help-circle
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Para abonar saldo a tu cuenta de Eato, deberás indicar cuál es la cantidad que vas a depositar, de lo contrario el sistema rechazará el depósito.
                  </span>
                </v-tooltip> -->
              </div>
            </v-card-title>
            <v-card-text class="text-center">
              <div class="title mb-4">
                Saldo disponible:
              </div>
              <div class="display-1 mb-8">
                <span data-cy="amountAvailable">
                  ${{ (detail.balance || {}).amountAvailable | toFixNumber(2) | numberWithComma }} {{ (detail.balance || {}).currency }}
                </span>
              </div>
              <div class="title mb-4">
                Saldo congelado:
              </div>
              <div class="display-1 mb-8">
                <span data-cy="amountWithheld">
                  ${{ (detail.balance || {}).amountWithheld | toFixNumber(2) | numberWithComma }} {{ (detail.balance || {}).currency }}
                </span>
              </div>
              <div v-if="balancePermissions['increase-balance']">
                <AddBalance
                  v-if="(detail.paymentData && detail.paymentData.source && !detail.paymentData.account)"
                  :available-balance="(detail.balance || {}).amountAvailable"
                  :commission="detail.fees.purchaseOrder"
                  :payment-data="detail.paymentData"
                  @update="load"
                />
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <ScheduledDeposit
            v-if="balancePermissions['read-scheduled-deposits']"
          />
        </v-col>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import Balance from '@/models/Balance'
import Restaurant from '@/models/Restaurant'
import AddBalance from '@/components/modals/AddBalance'
import ScheduledDeposit from '@/components/tables/ScheduledDeposits'

export default {
  name: 'Balance',
  components: {
    AddBalance,
    ScheduledDeposit
  },
  data () {
    const balanceModel = new Balance({ restaurant: this.restaurant })
    const restaurantModel = new Restaurant()
    return {
      loading: false,
      restaurantModel,
      balanceModel,
      detail: {},
      taxInformation: {}
    }
  },
  computed: {
    balancePermissions () {
      return this.$store.state.login.permissions['my-management'].components['add-balance'].actions
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    }
  },
  watch: {
    async restaurant () {
      await this.load()
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    async load () {
      try {
        this.restaurantModel.set(this.restaurant)
        const res = await this.restaurantModel.detail()
        const taxInformation = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/settings`)
        this.detail = res.response.data
        this.taxInformation = taxInformation
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    async generateClabe () {
      this.loading = true
      try {
        await this.$api.post(`/v2/marketplace/restaurants/${this.restaurant._id}/generate-clabe`)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.loading = false
      await this.load()
    }
  }
}
</script>
